const TAG_LABELS: Record<string, string> = { new: 'New', imp: 'Improved', fix: 'Fix' };

export const tagLabel = (tag: string): string => TAG_LABELS[tag] ?? tag;

/**
 * A release's date. Stored as noon UTC for a calendar day, so it is formatted in UTC: in the
 * local zone it could read as the day before.
 */
export function releaseDate(value: unknown): string {
  const date = new Date(value as string | Date);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

/** Newest-first notes grouped by minor, keeping the order they arrived in. */
export function groupByMinor<T extends { minorKey: string }>(
  notes: T[],
): { minorKey: string; notes: T[] }[] {
  const groups: { minorKey: string; notes: T[] }[] = [];
  for (const note of notes) {
    const last = groups[groups.length - 1];
    if (last && last.minorKey === note.minorKey) last.notes.push(note);
    else groups.push({ minorKey: note.minorKey, notes: [note] });
  }
  return groups;
}
